import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

const LoyaltyPage = lazy(() => import("./web/LoyaltyPage.js").then((m) => ({ default: m.LoyaltyPage })));

export default defineWebModule({ manifest, pages: { "": LoyaltyPage } });
